/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Alert, HFlow, Icon, Text, Theme, useTheme, VFlow } from 'bold-ui'
import { Fragment } from 'react'
import { categoriaImcReferenciaRecord } from 'view/atendimentos/detail/components/modals/medicoes/graficos/pre-natal/ganho-peso/model-graficoGanhoPeso'
import { getCategoriaImcReferencia } from 'view/atendimentos/detail/components/modals/medicoes/graficos/pre-natal/ganho-peso/util-graficoGanhoPeso'

interface ImcPreGestacionalCardItemProps {
  imc: number
}

export const ImcPreGestacionalCardItem = (props: Readonly<ImcPreGestacionalCardItemProps>) => {
  const { imc } = props

  const categoriaImcReferencia = getCategoriaImcReferencia(imc)
  const alertType = categoriaImcReferenciaRecord[categoriaImcReferencia].alertType

  const theme = useTheme()
  const styles = createStyles(theme)

  return (
    <Fragment>
      <VFlow vSpacing={0.5}>
        <HFlow hSpacing={0.5} alignItems='flex-start'>
          <Icon icon='imcFilled' />
          <VFlow vSpacing={0.125}>
            <div>
              <Text fontWeight='bold' style={styles.title}>
                IMC pré-gestacional
              </Text>
              <Text style={styles.value}>{imc + ' kg/m²'}</Text>
            </div>
            <Alert
              inline
              type={alertType}
              styles={{
                wrapper: [styles.alertIcon, styles.alertImcWrapper],
              }}
            >
              {categoriaImcReferencia}
            </Alert>
          </VFlow>
        </HFlow>

        <Alert
          type='info'
          styles={{
            wrapper: styles.alertIcon,
          }}
        >
          Utilize o gráfico de ganho de peso para monitoramento adequado.
        </Alert>
      </VFlow>
      <hr css={styles.bottomLine} />
    </Fragment>
  )
}

const createStyles = (theme: Theme) => ({
  title: css`
    margin-right: 0.375rem;
    ${theme.breakpoints.up('lg')} {
      &:after {
        content: ':';
      }
    }
  `,
  value: css`
    ${theme.breakpoints.down('lg')} {
      display: block;
    }
  `,
  alertIcon: css`
    svg {
      width: 1rem;
      height: 1rem;
    }
  `,
  alertImcWrapper: css`
    background-color: transparent;
    border-width: 0;
    padding: 0;
    min-height: 0;
  `,

  bottomLine: css`
    margin: 0.75rem 0 0 0;
  `,
})
